import { render, staticRenderFns } from "./StadiumBoostCreateForm.vue?vue&type=template&id=30012956&"
import script from "./StadiumBoostCreateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30012956')) {
      api.createRecord('30012956', component.options)
    } else {
      api.reload('30012956', component.options)
    }
    module.hot.accept("./StadiumBoostCreateForm.vue?vue&type=template&id=30012956&", function () {
      api.rerender('30012956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostCreateForm.vue"
export default component.exports